/* eslint-disable prettier/prettier */

import { Outlet } from 'react-router-dom';
import NavCoachMentorDashboard from './NavCoachMentorDashboard';

const CoachMentorDashboard: React.FC = () => {
	return (
		<>
			<NavCoachMentorDashboard />
			<Outlet />
		</>
	);
};

export default CoachMentorDashboard;
